import { render } from "./CatalogoLocalDeTrabalho.vue?vue&type=template&id=13f71195&ts=true"
import script from "./CatalogoLocalDeTrabalho.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoLocalDeTrabalho.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/apresentacao/CatalogoLocalDeTrabalho.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13f71195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13f71195', __exports__)) {
    api.reload('13f71195', __exports__)
  }
  
  module.hot.accept("./CatalogoLocalDeTrabalho.vue?vue&type=template&id=13f71195&ts=true", () => {
    api.rerender('13f71195', render)
  })

}


export default __exports__